import { call, put, all, takeLatest } from "redux-saga/effects";

import { userActions } from "./user.reducer";

import { getUser } from "../../apis/user-pet.apis";

export function* signIn(action: any) {
  try {
    const user: {
      pkCollection: string;
      nickname: string;
      stripeCustomerId: string;
      created: number;
      dataCollection: string;
      email: string;
    } = yield call(getUser, action.payload);

    yield put(userActions.signInSuccess(user));
  } catch (error) {
    yield put(userActions.signInFailure(error));
  }
}

export function* onSignInStart() {
  yield takeLatest(userActions.signInStart.type, signIn);
}

export function* signOut() {
  try {
    yield put(userActions.signOutSuccess());
  } catch (error) {
    yield put(userActions.signOutFailure(error));
  }
}

export function* onSignOutStart() {
  yield takeLatest(userActions.signOutStart.type, signOut);
}

export function* userSagas() {
  yield all([call(onSignInStart), call(onSignOutStart)]);
}
